import { api } from 'utils/apis/api';
import { transformCreateChatbotConfigurationResponse, transformReadChatbotConfigurationsResponse, } from './utils/transformResponse';
export const chatbotsApi = api
    .enhanceEndpoints({
    addTagTypes: ['Chatbots'],
})
    .injectEndpoints({
    endpoints: (builder) => ({
        readChatbotById: builder.query({
            query: ({ id }) => ({
                version: 1,
                path: `chatbots/${id}`,
            }),
        }),
        readChatbots: builder.query({
            query: () => ({
                version: 1,
                path: 'chatbots',
            }),
            transformResponse: transformReadChatbotConfigurationsResponse,
            providesTags: ['Chatbots'],
        }),
        createChatbot: builder.mutation({
            query: ({ url, _type }) => ({
                version: 1,
                path: 'chatbots',
                method: 'POST',
                body: { url, _type },
            }),
            transformResponse: transformCreateChatbotConfigurationResponse,
            invalidatesTags: ['Chatbots'],
        }),
        deleteChatbot: builder.mutation({
            query: ({ id }) => ({
                version: 1,
                path: `chatbots/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Chatbots'],
        }),
    }),
});
